import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';

const currentVersion = '0.2.8';

function installUpdate(version: string) {
  const url = new URL(window.location.href);
  url.searchParams.set('app-version', version);
  url.searchParams.set('updated-at', Date.now().toString());
  window.location.replace(url.toString());
}

export function UpdateBanner() {
  const [available, setAvailable] = useState('');
  useEffect(() => {
    let active = true;
    async function check() {
      try {
        const response = await fetch(`/version.json?t=${Date.now()}`, { cache: 'no-store' });
        if (!response.ok) return;
        const data = await response.json() as { version?: string };
        if (active && data.version && data.version !== currentVersion) setAvailable(data.version);
      } catch { /* Update checks must never interrupt the app. */ }
    }
    void check();
    const timer = window.setInterval(check, 5 * 60 * 1000);
    return () => { active = false; window.clearInterval(timer); };
  }, []);
  if (!available) return null;
  return <div className="update-banner" role="status"><span>A new Plessage version is ready.</span><button onClick={() => installUpdate(available)}><RefreshCw size={15}/> Update now</button></div>;
}
